import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'

import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
// Utils

import styles from './allReviews.module.scss'
import CrossIcon from './icons/Cross.inline.svg'
import Select, { SelectOptionProps } from './Select'

export interface ReviewsFilterProps {
  sortBy: SelectOptionProps[]
  setSortBy: (val: string) => void
  onSearchReview: (val: string) => void
  setHasPhoto: (val: boolean) => void
  hasPhoto: boolean
  className?: string
  variants?: any
  productProperties?: ProductProperties
  newPdpv2?: boolean
}

export const ReviewsFilter = ({ className = '', ...props }: ReviewsFilterProps) => {
  const { t } = useTranslation('common')
  useEffect(() => {
    props.onSearchReview('')
  }, [props.onSearchReview])

  return (
    <div className={classnames(styles.filterWrap, className, { [styles.filterWrap_newPdpv2 ?? '']: props.newPdpv2 })}>
      <div className={styles.filterWrap__left}>
        <Select
          label={t('sort_by')}
          options={props.sortBy}
          onChange={props.setSortBy}
          className={classnames(styles.filterOptionItem, styles.selectBoxWrap)}
          labelClassName={styles.selectBoxLabel}
          variants={props.variants}
          hasPhoto={props.hasPhoto}
          productProperties={props.productProperties}
        />
        <label className={classnames(styles.filterOptionItem, styles.photofilter)}>
          <span className={styles.photofilter__textAndInputWrapper}>{t('has_photo')} </span>
          <input
            data-testid="review-section-hasphoto"
            type="checkbox"
            // @i18n-ignore
            name="hasphoto"
            // eslint-disable-next-line
            value="yes"
            onChange={e => {
              props.setHasPhoto(e.target.checked)
            }}
          />
          <div className={styles.photofilter__checkbox}>
            {props.hasPhoto && <CrossIcon className={styles.photofilter__cross} />}
          </div>
        </label>
      </div>
    </div>
  )
}

export default ReviewsFilter
